<template>
  <div
    class="all-review-card-wrapper shadow-2 d-flex flex-column flex-lg-row nowrap bg-primary-white p-4 mx-1"
  >
    <div class="col-12 col-lg-2">
      <div class="d-flex flex-column nowrap body-strong text-grey-900">
        <div>
          <span v-if="formattedSurname">{{ formattedSurname }}</span>
          <span>{{ " " }}</span>
          <span v-if="review.authorName">{{ review.authorName }}.</span>
        </div>
        <div class=" body text-grey-600">
          <span>{{ getCreatedDatePretty(review.creationDate) }}</span>
        </div>
        <div class="d-flex flex-row body-strong text-grey-900">
          <span class="me-1">{{ formattedRatingByLocale }}/5</span>
          <svg class="icon text-primary-blue"
            width="16"
            height="16"
            style="position: relative; top: 2px;">
            <use href="#___icon___star-full"></use>
          </svg>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-10 body text-grey-900">
            
      <template v-if="review.customerComment">
      <TranslatedComment :review="review" />


					<div v-if="review.liheAnswer"
						class="bg-blue-100 p-4 mt-4"
						style="border-radius: var(--border-radius-default);"
					>
						<strong class="d-block mb-2 caption-strong text-grey-800">
							{{ content.reviews_response || 'Réponse de travelski' }}
						</strong>
					<!-- Answer text and toggle inline -->
						<div class="d-flex align-items-center justify-content-between">
							<p :style="clampStyle"
							class="m-0 caption text-grey-800 flex-grow-1"
							style="line-height:1.5;"
							>
							{{ displayedAnswer }}
							</p> 
							 <strong><span
								v-if="shouldShowToggle"
								@click="isAnswerExpanded = !isAnswerExpanded"
								class="d-inline-block mt-2 link-small cursor-pointer"
							>
								{{ isAnswerExpanded 
								? (content.reviews_seeLess || 'Lire moins')
								: (content.reviews_seeMore_popup || 'Lire la suite')
								}}
          					</span></strong>
						</div>
            <!-- {{ content.reviews_originalLanguage }} -->
					</div>
      </template>
    </div>

  </div>
</template>

<script setup>

import { useStore } from 'vuex'
import { computed, watchEffect } from 'vue'
import { ref } from 'vue'
import TranslatedComment from '@/vue/reviews-translation/components/popups/translatedComment.vue'
import { getOverallReviewRatingValue } from '@/vue/reviews-translation/utils/overallReviewRating.js'


const isAnswerExpanded = ref(false)


const props = defineProps({
	review: {
		type: Object,
		default: () => ({}),
	},
	open: {
		type: Boolean,
		default: false,
	},
	ratings: {
		type: Array,
		default: () => [],
	},
})
console.log('[Review.vue] props.review:', props.review)

const emit = defineEmits(['closePopup'])

const store = useStore()
const language = computed(() => store.state.language)
const content = computed(() => store.state.content)
const siteLang = computed(() => language.value?.toLowerCase().slice(0, 2))

console.log('[Review.vue] site language:', language.value)
console.log('[Review.vue] siteLang:', siteLang.value)

const companyLangToLocale = new Map([
	['fr', 'fr-FR'],
	['en', 'en-US'],
	['nl', 'nl-NL'],
])

const formattedSurname = computed(() => {
  if (!props.review.authorSurname) return ''
  return props.review.authorSurname.charAt(0).toUpperCase() + '.'
})

watchEffect(() => {
	if (props.review.liheAnswer) {
		console.log('[ReviewPopup] Hotel answer received:', props.review.liheAnswer)
	}
})

function getCreatedDatePretty(dateStr) {
	const dateObj = new Date(dateStr)
	const options = { year: 'numeric', month: 'long', day: 'numeric' }

	let locale = language.value

	if (locale === 'fr-FR-CSE') {
		const match = document.cookie.match('(^|;)\\s*companyLang\\s*=\\s*([^;]+)')
		if (match && match[2]) {
			const shortLang = decodeURIComponent(match[2]).trim()
			const mappedLocale = companyLangToLocale.get(shortLang)
			locale = mappedLocale || 'en-US'
		} else {
			locale = 'en-US'
		}
	}

	try {
		return dateObj.toLocaleString(locale, options)
	} catch (error) {
		console.error('Date formatting error:', error)
		return dateObj.toLocaleString('en-US', options)
	}
}

function handleClosePopup() {
	emit('closePopup')
}


const formattedRatingByLocale = computed(() => {
	const overall = getOverallReviewRatingValue(props.review) ?? 0
	const raw = overall.toFixed(1).replace(/\.0$/, '') || '0'
	if (language.value === 'fr-FR' || language.value === 'fr-FR-CSE') {
		return raw.replace('.', ',')
	}
	return raw
})

function extractSiteSegment(raw) {
  if (!raw || typeof raw !== 'string') return ''

  const parts = raw.split(/\s*\|\s*/)
  const langMap = {}

  parts.forEach(part => {
    const match = part.match(/^(\w{2}):\s*(.+)$/s)
    if (match) {
      const lang = match[1].toLowerCase()
      langMap[lang] = match[2].trim()
    }
  })

  const siteLang = language.value.slice(0, 2).toLowerCase()

  // Try siteLang first, then fallback to 'fr', then any available
  return langMap[siteLang] || langMap['fr'] || Object.values(langMap)[0] || raw
}

const displayedAnswer = computed(() => {
  const seg = extractSiteSegment(props.review.liheAnswer)
  console.log('[Review.vue] displayedAnswer segment:', seg)
  return seg
})

// Style for clamp
const clampStyle = computed(() => isAnswerExpanded.value
  ? {}  // no clamp when expanded
  : {
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: '1',
      overflow: 'hidden'
    }
)
// Show toggle only if text overflows one line (rough heuristic)
const shouldShowToggle = computed(() => {
  return displayedAnswer.value.split('\n').length > 1 || displayedAnswer.value.length > 100
})



</script>

<style>
.all-review-card-wrapper {
  border-radius: 20px; /* Custom radius, may need design system extension */
}
.hotel-comment-box {
  background-color: var(--blue-100);
  padding: 12px 16px;
  border-radius: var(--border-radius-default);
  line-height: 1.4;
  width: fit-content;
  max-width: 100%;
}

.text-truncated {
  display: inline;
  word-break: break-word;
  max-width: 100%;
}

.clamped {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: bottom;
  max-width: calc(100% - 80px); /* Leave room for 'Lire la suite' */
}

p {
    margin-bottom: 0 !important; 
}

</style>
